export interface Metadata {
  discount: string;
  sub: string;
}
export enum PlanTypes {
  classic,
  exec,
}

export interface Price {
  additionalFeatures: string[];
  amount: number;
  // Intentionally no checkoutUrl/Payment Link field. Membership payments must
  // use backend-created Checkout Sessions so backend UserPayment linkage exists
  // before Stripe subscription webhooks run. See docs/payments.md.
  displayPrice?: string;
  feature: string;
  frequency?: 'month' | 'year';
  id: { production: string; test: string };
  metadata?: Metadata;
  nickname?: string;
  pill: string;
  sub?: string;
  title: string;
  type: PlanTypes;
  unit_amount_decimal?: number;
}
